module.exports = __webpack_public_path__ + "8e81b628c494be7bcc083cd70926c0d4.png";